import { createContext, useContext, useEffect, useMemo, useState } from "react";

export const CURRENCIES = {
  GBP: { symbol: "£", rate: 1, label: "GBP £", locale: "en-GB" },
  USD: { symbol: "$", rate: 1.27, label: "USD $", locale: "en-US" },
  EUR: { symbol: "€", rate: 1.17, label: "EUR €", locale: "de-DE" },
  AED: { symbol: "AED ", rate: 4.66, label: "AED د.إ", locale: "en-AE" },
  PKR: { symbol: "₨", rate: 355, label: "PKR ₨", locale: "en-PK" },
  BDT: { symbol: "৳", rate: 150, label: "BDT ৳", locale: "en-BD" },
};

const CurrencyContext = createContext(null);
export const useCurrency = () => useContext(CurrencyContext);

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => localStorage.getItem("ida_currency") || "GBP");

  useEffect(() => {
    localStorage.setItem("ida_currency", code);
  }, [code]);

  const value = useMemo(() => {
    const c = CURRENCIES[code] || CURRENCIES.GBP;
    const convert = (gbp) => gbp * c.rate;
    const format = (gbp, opts = {}) => {
      const v = convert(gbp);
      const digits = c.rate >= 100 ? 0 : opts.digits ?? (Number.isInteger(v) ? 0 : 2);
      return `${c.symbol}${v.toLocaleString(c.locale, { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
    };
    return { code, setCode, currency: c, convert, format };
  }, [code]);

  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}
